function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C6.09223 0 3.72656 2.36566 3.72656 5.27344C3.72656 8.18121 6.09223 10.5469 9 10.5469C11.9078 10.5469 14.2734 8.18121 14.2734 5.27344C14.2734 2.36566 11.9078 0 9 0Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5612 13.992C14.1174 12.5261 12.2035 11.7188 10.1719 11.7188H7.82812C5.79656 11.7188 3.88258 12.5261 2.43883 13.992C1.00215 15.4507 0.210938 17.3763 0.210938 19.4141C0.210938 19.7377 0.473281 20 0.796875 20H17.2031C17.5267 20 17.7891 19.7377 17.7891 19.4141C17.7891 17.3763 16.9979 15.4507 15.5612 13.992Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 18,
  r: 4.5,
  fill: "currentColor",
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.8828 17.2281L14.7727 19.3381C14.6164 19.4944 14.3629 19.4944 14.2065 19.3381L13.1172 18.2487C12.9609 18.0924 12.9609 17.8389 13.1172 17.6826C13.2736 17.5263 13.527 17.5263 13.6833 17.6825L14.4897 18.4889L16.3167 16.6619C16.473 16.5056 16.7265 16.5057 16.8828 16.6619C17.0391 16.8182 17.0391 17.0717 16.8828 17.2281Z",
  fill: "white"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 4,
  fill: "white",
  transform: "translate(13 16)"
})));

var SvgApplicationIcon = function SvgApplicationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApplicationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/application-icon.b3b4cfef.svg";
export { ForwardRef as ReactComponent };